import { render, staticRenderFns } from "./resend-email.vue?vue&type=template&id=3da7be36"
import script from "./resend-email.vue?vue&type=script&lang=js"
export * from "./resend-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports